import React from 'react'
import { useHistory } from 'react-router-dom'
import styles from './index.module.scss'
import PlateKeyboardV2 from '../../../components/PlateKeybord/indexV2'
import useBaseInfo from '../store/useBaseInfo'
import useGetCh from '../../../hooks/useGetCh'
import { reportUserBehavior } from '../../../utils/report'
import useHashModal from '../../../hooks/useHashModal'

export default function PlateInput () {
  const history = useHistory()
  const ch = useGetCh()
  const { baseInfo, addPlateNumber } = useBaseInfo()

  const handleAddPlateNumber = plateNummber => {
    addPlateNumber(plateNummber)
    history.goBack()
  }

  const { visible } = useHashModal('#add-plate', {
    title: '补充车牌',
    onShow: () => {
      reportUserBehavior(
        {
          so: 'J001005',
          mcode: 'maintence_plate_input',
          ch,
          pa: `status=success`,
        },
        'page'
      );
    }
  });

  if (!visible) return null;

  return (
    <div className={styles.pagePlateInput}>
      <PlateKeyboardV2
        initPlateNumber={baseInfo?.addedPlateNumber}
        onConfirm={handleAddPlateNumber}
      />
    </div>
  )
}